import { StandaloneComponent } from '@/types/component';

// No common smart banner for all brands, each brand can implement it on its own

const SmartBanner: StandaloneComponent = () => null;

export default SmartBanner;
